// esilnt-disable
import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import middlewarePipeline from "../../middleware-pipeline";
import auth from "@/middleware/auth.js";
import metaTitle from "@/middleware/metaTitle.js";
import { AppCodes } from "@/utils/constants";
import { handleRouting } from "../utils/constants";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/auth/LoginView.vue"),
    meta: {
      title: "Login - Matta Trade",

      metaTags: [
        {
          name: "description",
          content: "Login in Matta account",
        },
        {
          property: "og:description",
          content: "Login in Matta account",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      } else {
        handleRouting();
      }
    },
  },
  {
    path: "/invited-user/:id",
    name: "register invited user",
    component: () =>
      import(
        /* webpackChunkName: "InvitedUser" */ "../views/auth/InvitedUser.vue"
      ),
    meta: {
      title: "Invited User - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Invited User in Matta account",
        },
        {
          property: "og:description",
          content: "Invited User in Matta account",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      }
    },
  },

  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () =>
      import(
        /* webpackChunkName: "ForgotPassword" */ "../views/auth/ForgotPassword.vue"
      ),
    meta: {
      title: "Forgot password - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Forgot your pasword",
        },
        {
          property: "og:description",
          content: "Forgot your pasword",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      } else {
        handleRouting();
      }
    },
  },
  {
    path: "/resend-verification/:email",
    name: "ResendVerification",
    component: () =>
      import(
        /* webpackChunkName: "ForgotPassword" */ "../views/auth/ResendVerification.vue"
      ),
    meta: {
      title: "Resend Verification - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Resend Verification",
        },
        {
          property: "og:description",
          content: "Resend Verification",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      } else {
        handleRouting();
      }
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () =>
      import(
        /* webpackChunkName: "ResetPassword" */ "../views/auth/ResetPassword.vue"
      ),
    meta: {
      title: "Reset Password - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Reset your matta password ",
        },
        {
          property: "og:description",
          content: "Reset your matta password ",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      } else {
        handleRouting();
      }
    },
  },
  {
    path: "/password-recovery",
    name: "PasswordRecovery",
    component: () =>
      import(
        /* webpackChunkName: "PasswordRecovery" */ "../views/auth/PasswordRecovery.vue"
      ),
    meta: {
      title: "Password Recovery - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Password Recovery success.",
        },
        {
          property: "og:description",
          content: "Password Recovery success.",
        },
      ],
    },
    beforeEnter: () => {
      if (store.getters.isLoggedIn) {
        return { name: "admin" };
      } else {
        handleRouting();
      }
    },
  },
  {
    path: "/auth/validate",
    name: "AuthValidate",
    component: () =>
      import(
        /* webpackChunkName: "AuthValidate" */ "../views/auth/Validate.vue"
      ),
    meta: {
      title: "Auth Validate - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Auth Validate.",
        },
        {
          property: "og:description",
          content: "Auth Validate.",
        },
      ],
    },
  },

  {
    path: "/",
    name: "admin",
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/AdminOverview.vue"),
    children: [
      {
        path: "",
        name: "dashboard storefront metrics",
        component: () =>
          import(
            /* webpackChunkName: "admindashboardOverview" */ "@/components/admin/dashboard/index.vue"
          ),
        meta: {
          title: "Dashboard",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "overview page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "overview page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Storefront",
              url: "#",
            },
            {
              name: "overview",
              url: "#",
            },
          ],
          appIds: Object.values(AppCodes),
          requiresAuth: true,
        },
      },
      {
        path: "dashboard",
        name: "storefront metrics",
        component: () =>
          import(
            /* webpackChunkName: "adminOverview" */ "@/components/admin/dashboard/index.vue"
          ),
        meta: {
          title: "Dashboard",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "overview page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "overview page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Storefront",
              url: "#",
            },
            {
              name: "overview",
              url: "#",
            },
          ],
          appIds: Object.values(AppCodes),
          requiresAuth: true,
        },
      },
      {
        path: "/administrators",
        name: "Oxide administrators",
        component: () =>
          import(
            /* webpackChunkName: "OxideAdministrators" */ "../views/Administrators.vue"
          ),
        meta: {
          title: "Oxide Administrators",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Settings page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Settings page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Account",
              url: "#",
            },
            {
              name: "Settings",
              url: "#",
            },
          ],
          appIds: [AppCodes.oxide],
        },
      },
      {
        path: "approved-customers",
        name: "Customers",
        component: () =>
          import(
            /* webpackChunkName: "approved-customers" */ "@/components/admin/ApprovedCustomers.vue"
          ),
        meta: {
          title: "Customers",
          roles: ["superadmin", "admin"],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.oxide],
        },
      },
      {
        path: "approved-customers/new-credit-request",
        name: "Create Approved Credit",
        component: () =>
          import(
            /* webpackChunkName: "create-approved-credit" */ "@/components/admin/CreateApprovedCredit.vue"
          ),
        meta: {
          title: "Create Credit Request",
          roles: ["superadmin", "admin"],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.oxide],
        },
      },
      {
        path: "metrics",
        name: "metrics",
        component: () =>
          import(
            /* webpackChunkName: "metrics" */ "@/components/admin/dashboard/Metrics.vue"
          ),
        meta: {
          title: "Dashboard",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "metrics page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "metrics page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "dashboard",
              url: "#",
            },
            {
              name: "metrics",
              url: "#",
            },
          ],
          appIds: Object.values(AppCodes),
        },
      },
      {
        path: "settings",
        name: "admin settings",
        component: () =>
          import(
            /* webpackChunkName: "adminSettingsOverview" */ "@/components/admin/SettingsComponent.vue"
          ),
        meta: {
          title: "Settings",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Settings page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Settings page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Account",
              url: "#",
            },
            {
              name: "Settings",
              url: "#",
            },
          ],
          appIds: Object.values(AppCodes),
        },
      },

      {
        path: "wallets",
        component: () =>
          import(
            /* webpackChunkName: "Administratorwallets" */ "@/views/WalletsComponent.vue"
          ),
        children: [
          {
            path: "",
            name: "wallets",
            component: () =>
              import(
                /* webpackChunkName: "AdministratorwalletsList" */ "@/components/admin/wallets/WalletsComponent.vue"
              ),
            meta: {
              title: "Wallets",
              roles: ["superadmin", "admin", "admin"],
              allowed: ["CompanyAdmin"],
              metaTags: [
                {
                  name: "description",
                  content: "Wallets page of Matta Trade.",
                },
                {
                  property: "og:description",
                  content: "Wallets page Matta Trade.",
                },
              ],
              breadcrumbs: [
                {
                  name: "overview",
                  url: "/",
                },

                {
                  name: "Agents",
                  url: "#",
                },
              ],
              middleware: [auth, metaTitle],
              appIds: Object.values(AppCodes),
            },
          },
          {
            path: "/wallets/wallet-transactions",
            name: "wallet transactions",
            component: () =>
              import(
                /* webpackChunkName: "customersettings" */ "@/components/admin/wallets/WalletTransaction.vue"
              ),

            meta: {
              title: "Wallet transaction",
              roles: [
                "superadmin",
                "admin",
                "admin",
                "sales",
                "commercial",
                "finance",
                "agent",
              ],
              metaTags: [
                {
                  name: "description",
                  content: "Customer settings page of Matta Trade.",
                },
                {
                  property: "og:description",
                  content: "Customer settings page Matta Trade.",
                },
              ],
              breadcrumbs: [
                {
                  name: "overview",
                  url: "/",
                },
                {
                  name: "wallets",
                  url: "/wallets",
                },
                {
                  name: new URL(window.location.toString()).searchParams.get(
                    "customerName"
                  ),
                  url: "#",
                },
              ],
              middleware: [auth, metaTitle],
              appIds: Object.values(AppCodes),
            },
          },
        ],
      },
      {
        path: "/fx-transfers",
        name: "fx transfers",
        component: () =>
          import(
            /* webpackChunkName: "fxtranfers" */ "../views/fxtransfer/index.vue"
          ),
        children: [
          {
            path: "",
            name: "metrics",
            component: () =>
              import(
                /* webpackChunkName: "fxtranfersDashboard" */ "../views/fxtransfer/metrics.vue"
              ),
          },
          {
            path: "transactions",
            name: "transactions",
            component: () =>
              import(
                /* webpackChunkName: "fxtranferstransactions" */ "../views/fxtransfer/transactions.vue"
              ),
          },
          {
            path: ":id/detail",
            name: "transaction detail",
            component: () =>
              import(
                /* webpackChunkName: "fxtranferstransactiondetail" */ "../views/fxtransfer/details.vue"
              ),
          },
          {
            path: "fees",
            name: "fees",
            component: () =>
              import(
                /* webpackChunkName: "fxtranfersfees" */ "../views/fxtransfer/fees.vue"
              ),
          },
        ],
        meta: {
          title: "Oxide Administrators",
          roles: [
            "superadmin",
            "admin",
            "manager",
            "controller",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Settings page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Settings page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Account",
              url: "#",
            },
            {
              name: "Settings",
              url: "#",
            },
          ],
          appIds: [AppCodes.oxide],
        },
      },
      {
        path: "notifications",
        name: "admin notifications",
        component: () =>
          import(
            /* webpackChunkName: "adminnotifications" */ "@/components/admin/NotificationComponent.vue"
          ),
        meta: {
          title: "Notifications",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Notifications page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Notifications page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Account",
              url: "#",
            },
            {
              name: "notifications",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: Object.values(AppCodes),
        },
      },

      {
        path: "orders",
        name: "Orders",
        component: () =>
          import(
            /* webpackChunkName: "Adminorders" */ "@/components/admin/OrdersComponent.vue"
          ),
        meta: {
          title: "Orders",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Orders page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Orders page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },
            {
              name: "orders",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.matta],
        },
      },
      {
        path: "shipping-management",
        name: "Shipping Management",
        component: () =>
          import(
            /* webpackChunkName: "ShippingManagement" */ "@/components/admin/ShippingManagement.vue"
          ),
        meta: {
          title: "Shipping Management",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Shipping Management page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Shipping Management page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },
            {
              name: "Shipping Management",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.matta],
        },
      },
      {
        path: "financing",
        name: "Financing",
        component: () =>
          import(
            /* webpackChunkName: "Financing" */ "@/views/FinancingRequests.vue"
          ),
        children: [
          {
            path: "",
            name: "Financing requests",
            component: () =>
              import(
                /* webpackChunkName: "FinancingRequests" */ "@/components/admin/FinanceRequest/RequestsTable.vue"
              ),
          },
          {
            path: "request/:type/:id",
            name: "Financing request ",
            component: () =>
              import(
                /* webpackChunkName: "RequestFinancing" */ "@/components/admin/FinanceRequest/Form/indexFinance.vue"
              ),
          },
          {
            path: "requests/:type/:id",
            name: "Financing requests details",
            component: () =>
              import(
                /* webpackChunkName: "FinancingRequest" */ "@/components/admin/FinanceRequest/Trade/indexFinance.vue"
              ),
          },
          {
            path: "transactions/:name/:id",
            name: "Financing transactions",
            component: () =>
              import(
                /* webpackChunkName: "TransactionsFinancingRequest" */ "@/components/admin/FinanceRequest/TransactionHistory.vue"
              ),
          },
        ],
        meta: {
          title: "Financing",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Financing page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Financing page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },
            {
              name: "Financing",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: Object.values(AppCodes),
        },
      },
      {
        path: "credit",
        name: "credit",
        component: () =>
          import(
            /* webpackChunkName: "credit" */ "@/views/FinancingRequests.vue"
          ),
        children: [
          {
            path: ":type/:businessId/:id",
            name: "Credit requests details",
            component: () =>
              import(
                /* webpackChunkName: "creditrequest" */ "@/components/admin/FinanceRequest/Trade/indexFinance.vue"
              ),
          },
        ],
        meta: {
          title: "Credit Detail",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Financing page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Financing page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },
            {
              name: "Financing",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: Object.values(AppCodes),
        },
      },
      {
        path: "/payment-management",
        name: "Payouts & Settlements",
        component: () => import("@/views/PaymentManagement.vue"),
        meta: {
          title: "Payouts & Settlements",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Payouts & Settlements page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Payouts & Settlements page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },
            {
              name: "Payouts & Settlements",
              url: "/payment-management", // Correct breadcrumb URL
            },
          ],
          middleware: [auth, metaTitle],
          appIds: Object.values(AppCodes),
        },
        children: [
          {
            path: "",
            name: "Payouts & Settlements Index",
            component: () =>
              import("@/components/admin/PaymentManagement/IndexComponent.vue"),
          },
        ],
      },

      {
        path: "logs",
        name: "Logs my Requests",
        component: () =>
          import(
            /* webpackChunkName: "Logs" */ "@/components/admin/LogsComponent.vue"
          ),
        meta: {
          title: "Logs",
          roles: ["superadmin", "admin", "admin"],
          allowed: ["CompanyAdmin", "CompanyUser"],
          metaTags: [
            {
              name: "description",
              content: "Logs page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Logs page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },

            {
              name: "Logs",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.matta],
        },
      },
      {
        path: "requests",
        name: "admin StoreRequests",
        component: () =>
          import(
            /* webpackChunkName: "adminstorerequests" */ "@/components/admin/StoreRequests.vue"
          ),
        meta: {
          title: "Requests",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          metaTags: [
            {
              name: "description",
              content: "Account requests page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Account requests page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "Overview",
              url: "/",
            },

            {
              name: "requests",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.matta],
        },
      },
      {
        path: "procurement/my-requests",
        name: "admin my Requests",
        component: () =>
          import(
            /* webpackChunkName: "adminMyrequests" */ "@/components/admin/MyRequests.vue"
          ),
        meta: {
          title: "My requests",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          allowed: ["CompanyAdmin", "CompanyUser"],
          metaTags: [
            {
              name: "description",
              content: "Account requests page of Matta Trade.",
            },
            {
              property: "og:description",
              content: "Account requests page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },
            {
              name: "procurement",
              url: "/procurement/my-orders",
            },
            {
              name: "my requests",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.matta],
        },
      },
      {
        path: "procurement/my-orders",
        name: "admin my orders",
        component: () =>
          import(
            /* webpackChunkName: "adminMyOrders" */ "@/components/admin/MyOrders.vue"
          ),
        meta: {
          title: "My Orders",
          roles: [
            "superadmin",
            "admin",
            "admin",
            "sales",
            "commercial",
            "finance",
            "agent",
          ],
          allowed: ["CompanyAdmin", "CompanyUser"],
          metaTags: [
            {
              name: "description",
              content: "My orders of Matta Trade.",
            },
            {
              property: "og:description",
              content: "My orders page Matta Trade.",
            },
          ],
          breadcrumbs: [
            {
              name: "overview",
              url: "/",
            },
            {
              name: "procurement",
              url: "/procurement/my-orders",
            },
            {
              name: "my orders",
              url: "#",
            },
          ],
          middleware: [auth, metaTitle],
          appIds: [AppCodes.matta],
        },
      },
    ],
    meta: {
      title: "Admin Dashboard - Matta Trade",
      metaTags: [
        {
          name: "description",
          content: "Admin Dashboard page of Matta Trade.",
        },
        {
          property: "og:description",
          content: "Admin Dashboard page Matta Trade.",
        },
      ],
      requiresAuth: true,
      isAdminRoute: true,
      middleware: [auth, metaTitle],
      appIds: Object.values(AppCodes),
    },
  },

  {
    path: "/:catchAll(.*)",
    name: "Not found",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "../views/NotFound.vue"),
  },
];
const scrollBehavior = (to, from, savedPosition) => {
  return savedPosition || { top: 0, left: 0 };
};
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }

  const middleware = to.meta.middleware;
  const context = {
    to,
    from,
    next,
    store,
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});
export default router;
